"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var index_1 = require("../index");

require("./index.less");

function Modal(props) {
  var xs = props.xs || 12;
  var sm = props.sm || xs;
  var md = props.md || sm;
  var lg = props.lg || md;
  var smOffset = Math.floor((12 - sm) / 2);
  var mdOffset = Math.floor((12 - md) / 2);
  var lgOffset = Math.floor((12 - lg) / 2);
  var sizeProps = {
    xs: xs,
    sm: sm,
    md: md,
    lg: lg,
    smOffset: smOffset,
    mdOffset: mdOffset,
    lgOffset: lgOffset
  };
  var classNames = ["overlay", "fullsize"];

  if (props.visible) {
    classNames.push("visible");
    classNames.push("fadein");
  }

  return React.createElement("div", {
    className: classNames.join(" ")
  }, React.createElement(index_1.Grid, null, React.createElement(index_1.Row, null, React.createElement(index_1.Col, __assign({}, sizeProps, {
    className: "pop-over"
  }), React.createElement("div", {
    className: "boxed"
  }, props.children)))));
}

exports["default"] = Modal;

var Header = function (_super) {
  __extends(Header, _super);

  function Header() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Header.prototype.render = function () {
    return React.createElement("div", __assign({
      className: "header-controls"
    }, this.props), this.props.children);
  };

  return Header;
}(React.Component);

exports.Header = Header;